import { SquareTerminal } from "lucide-react";

export const SimFab = ({ onOpen }) => (
  <button
    type="button"
    onClick={onOpen}
    className="sim-fab fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-40 flex items-center gap-3 rounded-full border px-4 sm:px-5 py-3 sm:py-3.5 text-sm font-semibold text-white"
    aria-label="Avvia Simulazione AI"
    aria-haspopup="dialog"
    data-testid="sim-fab"
  >
    <SquareTerminal className="h-5 w-5 text-cyan" strokeWidth={1.75} />
    <span className="hidden sm:inline">Avvia Simulazione AI</span>
    <span className="sm:hidden font-mono text-xs">Simula AI</span>
  </button>
);
